import { ArcElement, Chart } from "chart.js";
import React from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";
import { AxiosInterceptorProvider } from "./apis";
import ErrorBoundaryFallback from "./components/error-boundary-fallback";
import NotificationModal from "./components/notification-modal";
import { NotificationModalProvider } from "./components/notification-modal/provider";
import TokenProvider from "./contexts/token.context";
import UserProvider from "./contexts/user.context";
import "./index.css";
import RouterContainer from "./routes";

Chart.register(ArcElement);

const Root = (
  <>
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <BrowserRouter>
        <NotificationModalProvider>
          <NotificationModal />
          <AxiosInterceptorProvider>
            <UserProvider>
              <TokenProvider>
                <RouterContainer />
              </TokenProvider>
            </UserProvider>
          </AxiosInterceptorProvider>
        </NotificationModalProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </>
);

createRoot(document.getElementById("root")).render(Root);
